import CountUp from "react-countup";
import React, {useEffect, useState} from 'react';
import BackButton from "../../../Components/BackButton";
import TitlePages from "../../../Components/TitlePages";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  MainContainer,
  ButtonsDiv,
  ButtonCompanies,
  ButtonDeleteCompanies,
  ButtonAddCompanies,
  RoundsNBlackout,
  InfoMain,
  InfoDiv,
  ButtonRequest,
  InputAddIndustry,
  UserDiv,
  ListPlayers,
  Margin
} from "./style";
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } from "react-dom/cjs/react-dom.development";



const SetupIndustry = () => {

  const [fornecedores, setFornecedores] = useState([])
  const [insumos, setInsumos] = useState([])
  const [showInputToAddIndustry, setShowInputToAddIndustry] = useState(false)
  const [showLista, setShowLista] = useState(false)
  const [idFornecedor, setIdFornecedor] = useState(0)
  const [showInsumosQuantity, setShowInsumosQuantity] = useState(false)
  const [listaPlayers, setListaPlayers] = useState(null)
  const [listaUsers, setListaUsers] = useState(null)
  const [FornecedorName, setFornecedorName] = useState(null)
  const [fornecedorConfiabilidade, setFornecedorConfiabilidade] = useState('')
  const [fornecedorLeadTime, setFornecedorLeadTime] = useState('')
  const [fornecedorQntMin, setFornecedorQntMin] = useState('')
  const [selectedInsumo, setSelectedInsumo] = useState('')
  const [fornecedorLote, setFornecedorLote] = useState('')
  const [fornecedorPreco, setFornecedorPreco] = useState('')
  const [insumosQuantity, setInsumosQuantity] = useState('')


  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  function deleteInsumoInProduct(id) {

    api.post(
      `/api/fornecedor/apagarInsumo/3`
    )
    .then(response => console.log(response))
    .catch(error => {
      return Promise.reject(error)
    })
  }

  //lista todos os jogadores da industria
  function listAllFornecedores(Fornecedor) {
    setIdFornecedor(Fornecedor.fornecedor)

    try {
        api.get("/api/insumo/listarTodos")
        .then(response => setInsumos(response.data))
      } catch(error) {
        console.log(error)
      }
    
    // setShowAllUsers(false)

    api.get(`/api/fornecedor/listarInsumos/${Fornecedor.fornecedor}`)
    .then(response => setListaPlayers(response.data))
    .catch(error => {
      return Promise.reject(error)
    })

    setShowLista(!showLista)

   
  }

  //adciona um novo jogador na industria
  function addInsumoToProduct(fornecedor) {

    const data = {
        "confiabilidade": fornecedorConfiabilidade,
        "fornecedor": fornecedor.fornecedor,
        "fornecedorInsumo": 0,
        "insumo": {
          "insumo": selectedInsumo,
          "nome": ""
        },
        "leadTime": fornecedorLeadTime,
        "loteEntrega": fornecedorLote,
        "preco": fornecedorPreco,
        "qtdMinima": fornecedorQntMin
      }
   

    api.post(`/api/fornecedor/adicionarInsumo`, data)
    .then(response => console.log(response.data))
    .catch(error => {
      return Promise.reject(error)
    })

    try {
        api.get(`/api/fornecedor/listarInsumos/${fornecedor.fornecedor}`)
        .then(response => setListaPlayers(response.data))
    } catch(e) {
        return Promise.reject(e)
    }

    
    
  }

  function addNewProduct() {
    const data = {
        "nome": FornecedorName,
        "fornecedor": 0
      }

    api.post("/api/fornecedor/cadastrar", data)
      .then(response => console.log(response))

    setShowInputToAddIndustry(false)
  }

  function deleteIndustry(id, nameIndustry) {

    const data = {
      "industria": id,
      "nome": nameIndustry
    }
     
    console.log(data)

    api.delete(
      "/api/industria/apagar",
      data
    )
    .then(response => console.log(response))
    .catch(error => {
      return Promise.reject(error)
    })
  }

  useEffect(() => {

    api.get("/api/fornecedor/listarTodos")
      .then(response => setFornecedores(response.data))
      .catch(error => {
          return error
      })
    

     

    
   
  }, [api])


  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Setup Indústria" />
        <BackButton path="/menuIndustry" />
        <Title>
          Número de Fornecedores <span>{fornecedores?.length}</span>
        </Title>
        <MainContainer>

          {fornecedores?.map((Fornecedor, k) => {

            return (
            <div key={k}>

              <ButtonsDiv  >
                <ButtonCompanies onClick={() => listAllFornecedores(Fornecedor)} >{Fornecedor.nome}</ButtonCompanies>
                <ButtonDeleteCompanies onClick={() => deleteIndustry(Fornecedor.fornecedor, Fornecedor.nome)} >X</ButtonDeleteCompanies>
              </ButtonsDiv>

              {
                showLista && Fornecedor.fornecedor === idFornecedor ? (
              
                
                  <UserDiv>
                        
                            <InfoMain>

                                {
                                    listaPlayers?.map((insumo) => {
                                        return <div style={{borderTop: "solid", padding: 10 }}>
                                     
                                          {insumo.insumo.nome}
                                        <InfoMain>
                                        
                                          <InfoDiv>
                                            <p>Quantidade Mínima:</p>
                                         
                                            <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={fornecedorQntMin} onChange={(e) => setFornecedorQntMin(e.target.value)}  placeholder={insumo.qtdMinima + " kg"} type="text" />
                                          
                                        </ButtonCompanies>
                                  
                                          </InfoDiv>
                                          <InfoDiv>
                                            <p>LeadTime:</p>
                                            <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={fornecedorLeadTime} onChange={(e) => setFornecedorLeadTime(e.target.value)} placeholder={insumo.leadTime + " dias"} type="number" /></ButtonCompanies>
                                      
                                          </InfoDiv>
                                          <InfoDiv>
                              
                                            <p>Atraso:</p>
                                            <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={fornecedorLote} onChange={(e) => setFornecedorLote(e.target.value)} placeholder={insumo.loteEntrega + " dias"} type="number" /></ButtonCompanies>
                                         
                                          </InfoDiv>
                                          <InfoDiv>
                              
                                            <p>Preço:</p>
                                            <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={fornecedorPreco} onChange={(e) => setFornecedorPreco(e.target.value)} placeholder={"R$ " + insumo.preco} type="number" /></ButtonCompanies>
                                     
                                          </InfoDiv>
                                          <InfoDiv>
                                            <p>Confiabilidade:</p>
                                            <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={fornecedorPreco} onChange={(e) => setFornecedorPreco(e.target.value)} placeholder={insumo.confiabilidade + "%"} type="number" /></ButtonCompanies>
                                       
                                          </InfoDiv>
                              
                                          <div style={{display: "flex", width: "100%", justifyContent: "center"}}>
                                            <ButtonCompanies style={{color: "orange", background: "#fff"}} onClick={() => addNewProduct(insumo)} >Atualizar Fornecedor</ButtonCompanies>
                                          </div>
                                          
                                          
                                        </InfoMain>

                              
                                             
                                        </div>
                                    })
                                }
                            
                          </InfoMain>     


               
                  </UserDiv>
              
                
                ) : (<></>)
              }
                       
            </div>
            )
          })}

          {

            showInputToAddIndustry &&
            <InfoMain>
            <InfoDiv>
              <p>Nome do Fornecedor:</p>
           
              <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={FornecedorName} onChange={(e) => setFornecedorName(e.target.value)}  placeholder="Ex. A" type="text" /></ButtonCompanies>
            
            </InfoDiv>
            

            <ButtonCompanies style={{color: "orange", background: "#fff"}} onClick={() => addNewProduct()} >Adicionar Fornecedor</ButtonCompanies>
           
            
            
          </InfoMain>

          }
          
    
          {/* <ButtonsDiv >
            <ButtonAddCompanies onClick={() => setShowInputToAddIndustry(!showInputToAddIndustry)} >+</ButtonAddCompanies>
          </ButtonsDiv> */}
        
          <ButtonRequest>EXPORTAR</ButtonRequest>
        </MainContainer>
      </SizeContainer>
    </Container>
  );
};
export default SetupIndustry;
